module.exports = __webpack_public_path__ + "img/main-collage.md.c084c7aa.jpg";